<template >
  <v-container
    p-0
    m-0
    class="_autoCompleteAnaContainer"
    style="padding-bottom: 1px; padding-top: 1px"
  >
    <v-row justify="center" p-0 m-0>
      <v-dialog v-model="edit" max-width="300px">
        <v-card>
          <v-card-text style="padding: 1px; border: 0px solid red">
            <!--NC-->
            <table>
              <tr>
                <th>NC</th>
                <th>NC Sub</th>
                <th>In.</th>
                <th>In.sub</th>
              </tr>
              <tr>
                <td>
                  <v-text-field
                    v-model="nc"
                    class="p-0 m-0"
                    style="max-width: 3rem; max-height: 1.5rem; margin-top: 1px"
                    height="2em"
                    hide-details
                    type="number"
                    dense
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="ncSub"
                    class="text-uppercase"
                    style="max-width: 3rem; max-height: 1.5rem; margin-top: 1px"
                    height="2em"
                    hide-details
                    dense
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="interno"
                    class="p-0 m-0"
                    style="max-width: 3rem; max-height: 1.5rem; margin-top: 1px"
                    height="2em"
                    type="number"
                    hide-details
                    dense
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="intSub"
                    class="p-0 m-0"
                    style="max-width: 3rem; max-height: 1.5rem; margin-top: 1px"
                    height="2em"
                    hide-details
                    dense
                  ></v-text-field>
                </td>
              </tr>
            </table>
          </v-card-text>
          <v-card-actions style="text-align: right">
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              small
              right
              outlined
              text
              @click="apply"
            >
              OK
            </v-btn>
            <v-btn
              color="blue darken-1"
              small
              right
              outlined
              text
              @click="edit = false"
            >
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row p-0 m-0>
      <v-text-field
        v-show="!edit"
        v-model="fullDes"
        color="primary"
        dark
        class="ncText"
        height="20px"
        dense
        hide-details
        p-0
        m-0
        :background-color="backGroundColor"
        outlined
        readonly
        v-on:click="editNc()"
        single-line
      >
      </v-text-field>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "AutoCompleteAna",
  props: {
    rilievo: {
      type: Object,
      required: true,
    },
    tipo: {
      type: String,
      required: true,
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  //props: ["rilievo","lpa","currentPrgComune","currentPrgAc"],

  data() {
    return {
      nc: 0,
      ncSub: "",
      interno: 0,
      intSub: "",
      fullDes: "xxx",
      edit: false,
      backGroundColor:"gray",
    };
  },

  created() {},
  mounted() {},
  beforeMount() {
    if (this.tipo == "N") {
        this.backGroundColor="primary";
      this.nc = this.rilievo.ncNuovo;
      this.ncSub = this.rilievo.ncNuovoSub;
      this.interno = this.rilievo.intNuovo;
      this.intSub = this.rilievo.intNuovoSub;
      this.fullDes = this.rilievo.desNN;
    } else if (this.tipo == "E") {
      this.nc = this.rilievo.ncEs;
      this.ncSub = this.rilievo.ncEsSub;
      this.interno = this.rilievo.intEs;
      this.intSub = this.rilievo.intEsSub;
      this.fullDes = this.rilievo.desNE;
    } else if (this.tipo == "U") {
      this.nc = this.rilievo.ncUtil;
      this.ncSub = this.rilievo.ncUtilSub;
      this.interno = this.rilievo.intUtil;
      this.intSub = this.rilievo.intUtilSub;
      this.fullDes = this.rilievo.desNU;
    }
  },

  methods: {
    apply() {
      let ret = "";
      if (this.nc != null) {
        ret = ret + this.nc;
      }
      if (this.ncSub != null) {
        ret = ret + this.ncSub;
      }
      if (this.interno != null || this.intSub != null) {
        ret = ret + " i.";
        if (this.interno != null) {
          ret = ret + this.interno;
        }
        if (this.intSub != null) {
          ret = ret + this.intSub;
        }
      }
      //update del modeelo
      if (this.tipo == "N") {
        this.rilievo.desNN = ret.toUpperCase();
        this.rilievo.ncNuovo=Number(this.nc);
        this.rilievo.ncNuovoSub=this.ncSub.toUpperCase();
        this.rilievo.intNuovo=Number(this.interno);
        //alert(Number(this.rilievo.intNuovo))
        this.rilievo.IntNuovoSub=this.intSub.toUpperCase();
        
      } else if (this.tipo == "E") {
        this.rilievo.desNE = ret.toUpperCase();
        this.rilievo.ncEs=Number(this.nc);
        this.rilievo.ncEsSub=this.ncSub.toUpperCase();
        this.rilievo.IntEs=Number(this.interno);
        this.rilievo.IntEsSub=this.intSub.toUpperCase();
      } else if (this.tipo == "U") {
        this.rilievo.desNU = ret.toUpperCase();
        this.rilievo.ncUtil=Number(this.nc);
        this.rilievo.ncUtiloSub=this.ncSub.toUpperCase();
        this.rilievo.IntUtil=Number(this.interno);
        this.rilievo.IntUtilSub=this.intSub.toUpperCase();
      }
      this.fullDes = ret;
      this.edit = false;
    },
    editNc(){
        if (!this.disabled){
this.edit = true;
        }
    },
    
  },
};
</script>
<style scoped>
th {
  font-size: 10px;
  font-weight: 400;
  padding: 0;
}
td {
  margin: 0;
  padding: 0px;
  border: 0px solid red;
}
</style>